module.exports = __webpack_public_path__ + "img/Cheer Megaphone05.81373cd2.jpg";